const TEAMS_LINK = `https://teams.microsoft.com`;

export const generateLinkByEmail = (supportUserEmail: string) => {
  return `${TEAMS_LINK}/l/chat/0/0?users=${encodeURIComponent(supportUserEmail)}`;
};
